var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7872_12153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69191 7.30565L12.4883 8.77427C13.1577 9.03403 13.1577 9.97315 12.4883 10.2329L8.69191 11.7015L7.22328 15.498C6.96353 16.1673 6.02441 16.1673 5.76465 15.498L4.29603 11.7015L0.499588 10.2329C-0.169785 9.97315 -0.169785 9.03403 0.499588 8.77427L4.29603 7.30565L5.76465 3.50921C6.02441 2.83984 6.96353 2.83984 7.22328 3.50921L8.69191 7.30565Z",
    fill: "#575F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0269 1.97065L15.7353 2.63003C16.085 2.75991 16.085 3.24945 15.7353 3.38932L14.0269 4.0487L13.3675 5.7571C13.2376 6.10677 12.7481 6.10677 12.6082 5.7571L11.9489 4.0487L10.2405 3.38932C9.89079 3.25944 9.89079 2.7699 10.2405 2.63003L11.9489 1.97065L12.6082 0.262254C12.7381 -0.0874181 13.2277 -0.0874181 13.3675 0.262254L14.0269 1.97065Z",
    fill: "#575F67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7872_12153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesSmall);
export default __webpack_public_path__ + "static/media/sparkles_small.c641a2dc7dda57c52bb72ae13f6cd3c5.svg";
export { ForwardRef as ReactComponent };